import { render, staticRenderFns } from "./parquesinfo.vue?vue&type=template&id=9f6dcec4"
import script from "./parquesinfo.vue?vue&type=script&lang=js"
export * from "./parquesinfo.vue?vue&type=script&lang=js"
import style0 from "./parquesinfo.vue?vue&type=style&index=0&id=9f6dcec4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports